import React, {SVGProps} from 'react';

export const CoParentLockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={22}
    viewBox="0 0 17 22"
    fill="none"
    {...props}>
    <path
      fill="#006A61"
      d="M2.275 21.34a2.19 2.19 0 0 1-1.607-.668A2.19 2.19 0 0 1 0 19.066V9.209c0-.625.223-1.161.668-1.606a2.19 2.19 0 0 1 1.607-.669h.839V5.108c0-1.416.495-2.62 1.486-3.615C5.591.496 6.792 0 8.203 0s2.613.497 3.604 1.492c.99.995 1.486 2.2 1.486 3.616v1.826h.839a2.19 2.19 0 0 1 1.606.668c.446.446.669.982.669 1.607v9.857a2.19 2.19 0 0 1-.669 1.607 2.19 2.19 0 0 1-1.606.668H2.275Zm0-2.274h11.857V9.209H2.275v9.857Zm5.928-2.928c.55 0 1.021-.196 1.413-.588.391-.392.587-.863.587-1.413s-.196-1.02-.587-1.412a1.926 1.926 0 0 0-1.413-.588c-.55 0-1.02.196-1.412.588a1.926 1.926 0 0 0-.588 1.412c0 .55.196 1.021.588 1.413.391.392.862.587 1.412.587ZM5.39 6.933h5.629V5.108c0-.787-.273-1.456-.818-2.007a2.703 2.703 0 0 0-1.997-.826c-.785 0-1.45.275-1.996.826a2.745 2.745 0 0 0-.819 2.007v1.826Z"
    />
  </svg>
);
